var collapsible_list_pair_rtlignore_default = {
  "container": "LGS8u",
  "title": "tPBE-",
  "viewerContainer": "_0YrDu",
  "titleContainer": "Ogdnu",
  "expandIcon": "ET4uk",
  "dndIcon": "kaK9q",
  "RTL": "y7Edh",
  "LTR": "_-9KHH",
  "itemContainer": "P7-wy",
  "itemContainerViewer": "U6e7m",
  "mouseDown": "tk6qj",
  "innerEditor": "pVGzm",
  "item": "_9dM-4",
  "floatingAddPluginMenuWrapper": "_8M2U9",
  "childrenHidden": "aG0pH"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
